import React, { useEffect, useState } from "react";
import "../Styles/SelectThemes.css";
import { FetchUserDataInSettings } from "../Utils/SettingsUserFetchMockData";
import ThemeSelector from "../Utils/themeSelector";
import { useNavigate } from "react-router-dom";

const SelectThemes = () => {
  const [explicitTheme, setExplicitTheme] = useState(
    JSON.parse(localStorage.getItem("explicitTheme")) || false
  );
  const [perProfileThemeEnabled, setPerProfileThemeEnabled] = useState(
    JSON.parse(localStorage.getItem("perProfileThemeEnabled")) || false
  );
  const [profileData, setProfileData] = useState([]);
  const [userid, setUserid] = useState("");
  const [updatedProfiles, setUpdatedProfiles] = useState({});
  const navigate = useNavigate();

  // Load global theme CSS
  useEffect(() => {
    localStorage.setItem("explicitTheme", JSON.stringify(explicitTheme));

    if (explicitTheme && typeof explicitTheme === "string") {
      import(`../Styles/themes/${explicitTheme}/themes.css`)
        .then(() => {
          console.log(`Loaded ${explicitTheme} styles for UserProfile`);
        })
        .catch(() => {
          console.error(`Theme CSS not found for ${explicitTheme}`);
        });
    }
  }, [explicitTheme]);

  // Fetch profile data & optionally load per-profile themes
  useEffect(() => {
    localStorage.setItem("perProfileThemeEnabled", JSON.stringify(perProfileThemeEnabled));

    const fetchData = async () => {
      const userData = await FetchUserDataInSettings();

      if (userData && Array.isArray(userData.profiles)) {
        const profilesWithUUID = userData.profiles.map((profile, index) => ({
          profileUUID: `uuid-${profile.profilename}-${index}`,
          ...profile,
        }));

        setUserid(userData.userId);
        setProfileData(profilesWithUUID);

        if (perProfileThemeEnabled) {
          profilesWithUUID.forEach((profile) => {
            const theme = profile.profiletheme;
            import(`../Styles/themes/${theme}/themes.css`)
              .then(() => {
                console.log(`Loaded ${theme} theme for profile ${profile.profilename}`);
              })
              .catch(() => {
                console.error(`Theme CSS not found for ${theme}`);
              });
          });
        }
      } else {
        console.warn("No profile data available.");
      }
    };

    fetchData();
  }, [perProfileThemeEnabled]);

  const handleThemeChange = (uuid, theme) => {
    setUpdatedProfiles((prev) => ({
      ...prev,
      [uuid]: {
        ...prev[uuid],
        profiletheme: theme,
      },
    }));

    import(`../Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} theme for ${uuid}`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
  };

  const handleSubmit = () => {
    const messages = profileData.map((profile) => {
      const uuid = profile.profileUUID;
      const updates = updatedProfiles[uuid] || {};

      const theme = updates.theme ?? profile.theme ?? "default";

      return `• ${profile.profilename}: Theme = "${theme}"`;
    });

    alert(`✅ Settings successfully updated for the following profiles:\n\n${messages.join("\n")}`);
  };

  const handleGoToProfiles = () => {
    navigate("/user-profiles/{userid}");
  };

  const handleProfileChange = (uuid, key, value) => {
    setUpdatedProfiles((prev) => ({
      ...prev,
      [uuid]: {
        ...prev[uuid],
        [key]: value,
      },
    }));
  };

  return (
    <div className="st-theme-container">
      <p className="st-text-header" style={{fontSize: 30, marginTop: 70}}>Theme Selection</p>

      <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <input
          type="checkbox"
          checked={explicitTheme}
          onChange={() => setExplicitTheme(!explicitTheme)}
        />
        <span className="st-text-label" style={{ fontFamily: "arial", fontSize: 18, marginTop: 20 }}>
          Enable Explicit Global Theme Selection
        </span>
      </label>

      {explicitTheme && <ThemeSelector />}

      <div style={{ marginTop: 30 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <input
            type="checkbox"
            checked={perProfileThemeEnabled}
            onChange={() => setPerProfileThemeEnabled(!perProfileThemeEnabled)}
          />
          <span className="st-text-label" style={{ fontFamily: "arial", fontSize: 18, marginTop: 20 }}>
            Enable Per-Profile Theme Customization
          </span>
        </label>

        {perProfileThemeEnabled && profileData.length > 0 && (
          <div
            style={{
              marginTop: 20,
              background: "black",
              padding: 20,
              borderRadius: 10,
            }}
          >
            <p style={{ fontFamily: "arial", color: "gray", fontSize: 30 }}>Profile Themes</p>
            {profileData.map((profile) => {
              const uuid = profile.profileUUID;
              const changes = updatedProfiles[uuid] || {};
              const currentTheme = profile.theme;

              return (
                <div
                  key={uuid}
                  style={{
                    padding: "10px 0",
                    background: "none",
                    width: 500,
                  }}
                >
                  <div>
                    <strong style={{color: "gray", fontSize: 20}}>{profile.profilename}</strong>
                  </div>
                  <div style={{color: "gray"}}>Current Theme: <span>{currentTheme}</span></div>
                  <div style={{ marginTop: 8 }}>
                    <label style={{ marginRight: 10, color: "gray" }}>Set New Theme:</label>
                    <select
                      value={changes.theme ?? profile.theme}
                      onChange={(e) =>
                        handleProfileChange(uuid, "theme", e.target.value)
                      }
                    style={{ background: "gray", color: "white" }}
                  >
                      <option value="shinyBlack">shinyBlack</option>
                      <option value="desertTitanium">desertTitanium</option>
                      <option value="milkyWhite">milkyWhite</option>
                      <option value="royalVelvet">royalVelvet</option>
                      <option value="dreamyLilac">dreamyLilac</option>
                      <option value="subsetRush">sunsetRush</option>
                      <option value="amberGlow">amberGlow</option>
                      <option value="blushPetal">blushPetal</option>
                      <option value="neoRose">neonRose</option>
                      <option value="iceMint">iceMint</option>
                      <option value="urbanSlate">urbanSlate</option>
                      <option value="skylineBlue">skylineBlue</option>
                    </select>
                  </div>
                </div>
              );
            })}
                      {/* ACTION BUTTONS */}
          <div style={{ display: "flex", gap: 20, marginTop: 20 }}>
            <button
              onClick={handleSubmit}
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Submit Settings
            </button>

            <button
              onClick={handleGoToProfiles}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Go to Profiles
            </button>
          </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectThemes;
